import { Inject, Injectable } from "@angular/core";

export const SIGN_WIDGET_URL_KEY = "signWidgetUrl";

@Injectable({
  providedIn: "root",
})
export class MedSignService {
  constructor(@Inject(SIGN_WIDGET_URL_KEY) private url: string) {
    this.signWidgetUrl = url || "";
  }

  readonly signWidgetUrl: string = "";
}
